import gql from 'graphql-tag'

export default gql`
query listSalesGroups($params: ListQueryArgs) {
	cashAssist {
		listSalesGroups(params: $params) {
			items {
				id
				name
				mod_ver
				acountNum
				discount
				clientDiscount {
					number
					percent
				}
			}
			hasNextPage
		}
	}
}`
